document.addEventListener('DOMContentLoaded', () => {
  const extraItemsLinks = document.querySelectorAll(
    '.news-section__bottom-link'
  );

  extraItemsLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();

      const isActive = link.classList.contains('active');

      // Убираем класс 'active' у всех ссылок и элементов extra-items
      extraItemsLinks.forEach((item) => {
        item.classList.remove('active');
        const bottomSection = item.closest('.news-section__bottom');
        const extraItems = bottomSection.querySelector('.extra-items');
        extraItems.classList.remove('active');
      });

      if (!isActive) {
        const bottomSection = link.closest('.news-section__bottom');
        const extraItems = bottomSection.querySelector('.extra-items');

        link.classList.add('active');
        extraItems.classList.add('active');
      }
    });
  });
});
